import * as screens from '@core/layouts/components/menu/screens';
import businessPartnersPaths from 'views/screens/BusinessPartners/paths';
import Icon from '../../utility/icomoon';

export default [
  {
    id: 'businessPartner',
    title: 'partners.businessPartner',
    icon: <Icon size={20} icon="Customers" />,
    iconName: 'Customers',
    permissions: [],
    navLink: businessPartnersPaths.editPartner,
    screenId: screens.BUSINESS_PARTNERS
  },
  {
    id: 'webServiceRates',
    title: 'partners.webServiceRates',
    icon: <Icon size={20} icon="WebService" />,
    iconName: 'WebService',
    permissions: [],
    navLink: businessPartnersPaths.webServiceRates,
    screenId: screens.WEB_SERVICE_RATES
  },
  {
    id: 'newComponents',
    title: 'partners.newComponents',
    icon: <Icon size={20} icon="WebService" />,
    iconName: 'Package',
    permissions: [],
    emailDomain: '@webtrackgps.net',
    navLink: businessPartnersPaths.newComponents
  },
  {
    id: 'publicReferencesMap',
    title: 'partners.publicReferencesMap',
    icon: <Icon size={20} icon="Marker1" />,
    iconName: 'Marker1',
    permissions: [],
    navLink: businessPartnersPaths.publicReferencesMap,
    screenId: screens.PUBLIC_REFERENCES_MAP
  },
  {
    id: 'teamActions',
    title: 'partners.teamActions',
    icon: <Icon size={20} icon="noun_steering_790455" />,
    iconName: 'noun_steering_790455',
    permissions: [],
    navLink: businessPartnersPaths.teamActions,
    screenId: screens.TEAM_ACTIONS
  },
  {
    id: 'featureFlags',
    title: 'partners.featureFlags',
    icon: <Icon size={20} icon="toggle_on" />,
    iconName: 'toggle_on',
    permissions: [],
    emailDomain: '@webtrackgps.net',
    navLink: businessPartnersPaths.featureFlags
  }
];
